import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from "../../hooks/useWebContext";
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import MetadataApliableFilterCard from '../../ui-parts/MetadataApliableFilterCard';
import { utility } from '../../utility';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import SearchResultListViewSearchResultCard from './SearchResultListViewSearchResultCard';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import SearchResultListViewSearchResultAdvCard from './SearchResultListViewSearchResultAdvCard';

/**
 * Search Result(List view) Page Component
 */
const SearchResultListView = (props) => {
  // 2024.5.8 MyMine Version1.5対応 Add Start
  const location = useLocation();
  const {
    searchValue,
    filterList,
    selectedId,
    // 2024.9.16 MyMine Version2.0対応 Add Start
    isLoadSearchKeyword,
    // 2024.9.16 MyMine Version2.0対応 Add End
    // 2024.12.23 MyMine Version2.1対応 Add Start
    isAdvancedSearch,
    // 2024.12.23 MyMine Version2.1対応 Add End
  } = location.state;
  // 2024.5.8 MyMine Version1.5対応 Add End
  const screenId = 'MyM401';
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  // 2024.5.8 MyMine Version1.5対応 Add Start
  const [isListLoading, setIsListLoading] = useState(false);
  const [isAdvancedSearchState, setIsAdvancedSearchState] = useState(isAdvancedSearch);
  // 2024.5.8 MyMine Version1.5対応 Add End
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [filterResult, setFilterList] = useState(null);
  // 2024.5.8 MyMine Version1.5対応 Modify Start
  const [selectedSortBy, setSelectedSortBy] = useState(selectedId ?? 0);
  const [apliableFilterList, setApliableFilterList] = useState(filterList ?? []);
  // 2024.5.8 MyMine Version1.5対応 Modify End
  const [isInitLoaded, setIsInitLoaded] = useState(false);
  // 2024.5.8 MyMine Version1.5対応 Add Start
  const [checkedList, setCheckedList] = useState(filterList ?? []);
  // 2024.5.8 MyMine Version1.5対応 Add End
  // 2024.9.16 MyMine Version2.0対応 Add Start
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2024.9.16 MyMine Version2.0対応 Add End

  // 2024.12.23 MyMine Version2.1対応 Modify Start
  // ソート順のDropDownList用変数
  const sortByDDL = [
    { text: controlSettings.LabelList.ddlSortBy1, sortItem: 'UPLOAD_DATE DESC' },
    { text: controlSettings.LabelList.ddlSortBy2, sortItem: 'UPLOAD_DATE ASC' },
    { text: controlSettings.LabelList.ddlSortBy3, sortItem: 'EXTENSION ASC' },
    { text: controlSettings.LabelList.ddlSortBy4, sortItem: 'NAME_DISP ASC' },
  ];
  // 2024.12.23 MyMine Version2.1対応 Modify End

  // 2024.12.23 MyMine Version2.1対応 Add Start
  if (isAdvancedSearch) {
    sortByDDL.unshift({ text: controlSettings.LabelList.ddlSortBy5, sortItem: 'SCORE_PRIORITY' });
  }
  sortByDDL.forEach((x, i) => x.value = i)
  // 2024.12.23 MyMine Version2.1対応 Add End

  /**
   * プレビュー処理
   * @param {Event} e イベント引数
   * @param {string} fileId ファイルID
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
    setIsModalOpen(true);
  }

  /**
   * SortByドロップダウンリスト変更時処理
   * @param {any} e イベント引数
   */
  const handleSortByChange = (e) => {
    setSelectedSortBy(e.target.value);
  }

  /** 初期表示時 */
  useEffect(() => {

    /**
     * 初期情報取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSearchResultLoadSuccess = (result) => {

      // 2024.12.23 MyMine Version2.1対応 Add Start
      if (isAdvancedSearchState && result.Result.IsAdvancedSearchExecuted === false) {
        alert(messageList.MyM_MSG_E_0137);
        setIsAdvancedSearchState(false);
      }
      // 2024.12.23 MyMine Version2.1対応 Add End

      setSearchResult(result.Result);
      setFilterList(result.FilterList);
      setIsLoading(false);
    }

    /**
     * 初期情報取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackSearchResultLoadFaild = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }

    // 2024.5.8 MyMine Version1.5対応 Modify Start
    const paramObj = {
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      // 2024.12.23 MyMine Version2.1対応 Modify Start
      LimitMaxRowCount: isAdvancedSearchState ? screenSettings.AdvMaxRowCount : screenSettings.MaxRowCount,
      // 2024.12.23 MyMine Version2.1対応 Modify End
      // 2024.9.16 MyMine Version2.0対応 Add Start
      IsEventSenderSearchKeyword: isLoadSearchKeyword === true,
      // 2024.9.16 MyMine Version2.0対応 Add End
      // 2024.12.23 MyMine Version2.1対応 Add Start
      IsRequestThumbnail: isAdvancedSearchState ?? false,
      isAdvancedSearch: isAdvancedSearchState ?? false,
      // 2024.12.23 MyMine Version2.1対応 Add End
      IsPc: isPc,
      SearchWord: utility.sanitize(searchValue) ?? '',
      ...(apliableFilterList.length > 0 ? {
        FilterMetadataIds: apliableFilterList.join(',')
      } : {})
    };
    // 2024.5.8 MyMine Version1.5対応 Modify End

    apiRequest.requestJson(`api/box-file/search-result-load?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSearchResultLoadSuccess, callbackSearchResultLoadFaild);

    setIsInitLoaded(true);
  }, []);

  /** フィルタ適用時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    if (pageNumber === 1) {
      requestSearch();
    } else {
      setPageNumber(1);
    }
  }, [apliableFilterList]);

  /** ソート/ページング切り替え時 */
  useEffect(() => {
    if (isInitLoaded === false) { return; }
    requestSearch();
  }, [pageNumber, selectedSortBy]);

  /** リクエスト処理  */
  const requestSearch = () => {

    /**
     * 一覧ページ取得正常コールバック処理
     * @param {any} result 処理結果
     */
    const callbackSuccessSearchResultPage = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (pageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(pageNumber - 1);
        return;
      }
      // 2024.5.8 MyMine Version1.5対応 Modify Start
      setSearchResult(Object.assign(searchResult, result));
      setIsListLoading(false);
      // 2024.5.8 MyMine Version1.5対応 Modify End
    }

    /**
     * 一覧ページ取得失敗コールバック処理
     * @param {any} result処理結果
     */
    const callbackFaildSearchResultPage = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      // 2024.5.8 MyMine Version1.5対応 Modify Start
      setIsListLoading(false);
      // 2024.5.8 MyMine Version1.5対応 Modify End
    }

    // 2024.5.8 MyMine Version1.5対応 Modify Start
    setIsListLoading(true);
    // 2024.5.8 MyMine Version1.5対応 Modify End

    const paramObj = {
      PageNumber: pageNumber,
      // 2024.12.23 MyMine Version2.1対応 Modify Start
      LimitMaxRowCount: isAdvancedSearchState ? screenSettings.AdvMaxRowCount : screenSettings.MaxRowCount,
      // 2024.12.23 MyMine Version2.1対応 Modify End
      SortItems: `${sortByDDL[selectedSortBy].sortItem}`,
      SearchWord: utility.sanitize(searchValue) ?? '',
      // 2024.12.23 MyMine Version2.1対応 Add Start
      IsRequestThumbnail: isAdvancedSearchState ?? false,
      IsAdvancedSearch: isAdvancedSearchState ?? false,
      // 2024.12.23 MyMine Version2.1対応 Add End
      // 2024.9.16 MyMine Version2.0対応 Modify Start
      IsPc: isPc,
      // 2024.9.16 MyMine Version2.0対応 Modify End
      // 2024.5.8 MyMine Version1.5対応 Modify Start
      ...(apliableFilterList.length > 0 ? {
        FilterMetadataIds: apliableFilterList.join(',')
      } : {})
      // 2024.5.8 MyMine Version1.5対応 Modify End
    };

    apiRequest.requestJson(`api/box-file/search-result-list-page?${utility.makeEncodeParameter(paramObj)}`, 'GET', callbackSuccessSearchResultPage, callbackFaildSearchResultPage);
  }

  if (searchResult === null)
    return <MyMProgress />

  // 2026.2.25 タブレット表示時対応 Add Start
  // 2024.12.23 MyMine Version2.1対応 Add Start
  const searchResultCardProps = {
    screenId: screenId,
    pageNumber: pageNumber,
    setPageNumber: setPageNumber,
    searchResult: searchResult,
    onSortByChange: handleSortByChange,
    onClickPreview: onClickPreview,
    controlSettings: controlSettings,
    messageList: messageList,
    sortByDDL: sortByDDL,
    keyword: searchValue,
    selectedSortBy: selectedSortBy,
    setIsLoading: setIsLoading,
    isListLoading: isListLoading,
    searchValue: utility.sanitize(searchValue) ?? '',
    apliableFilterList: apliableFilterList,
    apiRequest: apiRequest,
    metadataList: filterResult,
    checkedList: checkedList,
    setCheckedList: setCheckedList,
    setApliableFilterList: setApliableFilterList,
    ellipsisNumberMobile: screenSettings.EllipsisNumberMobile,
    ellipsisNumberPC: screenSettings.EllipsisNumberPC,
  };
  // 2024.12.23 MyMine Version2.1対応 Add End
  // 2026.2.25 タブレット表示時対応 Add End

  return (
    <Box className='pb-3' >
      <Grid container>
        {isLoading && <MyMProgress />}
        <Grid item xs={12} lg={9.3}>
          {/* 2024.12.23 MyMine Version2.1対応 Modify Start */}
          {isAdvancedSearchState
            ? <SearchResultListViewSearchResultAdvCard {...searchResultCardProps} />
            : <SearchResultListViewSearchResultCard {...searchResultCardProps} />
          }
          {/* 2024.12.23 MyMine Version2.1対応 Modify End */}
        </Grid>
        {isPc &&
          <Grid item xs={12} lg={2.7}>

            <MetadataApliableFilterCard
              cardTitle={controlSettings.LabelList.lblFilterResultsByTitle}
              metadataList={filterResult}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              // 2024.5.8 MyMine Version1.5対応 Add Start
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            // 2024.5.8 MyMine Version1.5対応 Add End
            />
          </Grid>
        }
      </Grid>
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </Box>
  );
}
export default SearchResultListView;